import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { Shipping } from '../models/Shipping';

interface ShippingListItemProps {
  shipping: Shipping;
}

const ShippingListItem: React.FC<ShippingListItemProps> = ({
  shipping,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + shipping.jan.toLowerCase()}
    >
      <IonItem>
        <IonLabel>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文番号 : {shipping.order_num},
          </p>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            {(shipping.status === 1) ? " 出荷完了" : ""}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(ShippingListItem);
